export default {
  login: {
    title: 'Đăng nhập',
    username: 'Tên người dùng',
    phone: 'Số điện thoại',
    phoneCode: 'Mã',
    email: 'Email',
    password: 'Mật khẩu',
    captcha: 'Mã xác nhận',
    loading: 'Đang tải...',
    rememberMe: 'Ghi nhớ đăng nhập',
    forgotPassword: 'Quên mật khẩu?',
    loginButton: 'Đăng nhập',
    contactUs: 'Liên hệ？',
    noAccount: 'Chưa có tài khoản?',
    registerNow: 'Đăng ký',
    or: 'HOẶC',
    orSignInWith: 'Hoặc đăng nhập bằng',
    methodUsername: 'Tên người dùng',
    methodPhone: 'Điện thoại',
    methodEmail: 'Email',
    usernameRequired: 'Vui lòng nhập tên người dùng',
    phoneRequired: 'Vui lòng nhập số điện thoại',
    emailRequired: 'Vui lòng nhập email',
    passwordRequired: 'Vui lòng nhập mật khẩu',
    captchaRequired: 'Vui lòng nhập mã xác nhận',
    resetPassword: 'Đặt lại mật khẩu',
    resetStep1Hint: 'Nhập số điện thoại hoặc email để nhận mã xác minh.',
    useEmailInstead: 'Dùng email',
    usePhoneInstead: 'Dùng điện thoại',
    sendCode: 'Gửi mã',
    resetStep2Hint: 'Mã xác minh đã được gửi đến',
    verificationCode: 'Mã xác minh',
    verificationCodeRequired: 'Vui lòng nhập mã xác minh',
    resendIn: 'Gửi lại sau',
    resendCode: 'Gửi lại mã',
    verify: 'Xác minh',
    resetStep3Hint: 'Đặt mật khẩu mới của bạn.',
    newPassword: 'Mật khẩu mới',
    confirmPassword: 'Xác nhận mật khẩu',
    passwordMinLength: 'Mật khẩu phải có ít nhất 6 ký tự',
    confirmPasswordRequired: 'Vui lòng xác nhận mật khẩu',
    passwordMismatch: 'Mật khẩu không khớp',
    resetPasswordBtn: 'Đặt lại mật khẩu',
    back: 'Quay lại',
    // Format validation
    emailFormat: 'Định dạng email không hợp lệ',
    // Toast messages
    loginSuccess: 'Đăng nhập thành công',
    loginFailed: 'Đăng nhập thất bại',
    signInWithGoogle: 'Đăng nhập bằng Google+',
    codeSent: 'Đã gửi mã xác minh',
    sendCodeFailed: 'Gửi mã thất bại',
    invalidCode: 'Mã xác minh không hợp lệ',
    resetSuccess: 'Đặt lại mật khẩu thành công',
    resetFailed: 'Đặt lại mật khẩu thất bại'
  }
};
